import AboutImg from '../../src/assets/about/plate.png';
import ModelWhiteImg from '../../src/assets/model-white.png';
import ModelBlackImg from '../../src/assets/model-black.png';
import MenuImg1 from '../../src/assets/menu/1.png';
import MenuImg2 from '../../src/assets/menu/2.png';
import MenuImg3 from '../../src/assets/menu/3.png';
import MenuImg4 from '../../src/assets/menu/4.png';
import Avatar1 from '../../src/assets/testimonial/avatar1.png';
import Avatar2 from '../../src/assets/testimonial/avatar2.png';
import Avatar3 from '../../src/assets/testimonial/avatar3.png';

export const navData = [
  { href: '/', name: 'home' },
  { href: '#about', name: 'about' },
  { href: '#menu', name: 'menu' },
  { href: '#testimonials', name: 'testimonials' },
  { href: '#reservations', name: 'reservations' },
  { href: '#contact', name: 'contact' },
];

export const heroData = {
  pretitle: 'Nothing brings together like',
  title: 'Bistro Café',
  subtitle:
    'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. ',
  btnText: 'Find out more',
};

export const aboutData = {
  pretitle: 'our story',
  title: 'who we are',
  subtitle:
    'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Amet consequatur, quasi minima molestiae ex exercitationem culpa quisquam architecto quaerat, iusto dolores labore, sapiente magni rem commodi aperiam ad dolorem neque ducimus. Placeat vel non quod quis pariatur a aperiam, aliquam adipisci voluptatum voluptatem sit cupiditate dolore natus beatae earum omnis.',
  btnText: 'find out more',
  image: AboutImg,
};

export const menuData = {
  title: 'delicious flavour of autumn',
  subtitle: 'view all menu for tasty meal today',
  modelImg: ModelWhiteImg,
  btnText: 'view complete menu',
  menuItems: [
    {
      image: MenuImg1,
      name: 'Chocolate Cake',
      price: 7.99,
      description: 'Class aptent taciti ciosqu litora torquent per',
    },
    {
      image: MenuImg2,
      name: 'Veggie Burger',
      price: 9.49,
      description: 'Class aptent taciti ciosqu litora torquent per',
    },
    {
      image: MenuImg3,
      name: 'King Burger',
      price: 8.50,
      description: 'Class aptent taciti ciosqu litora torquent per',
    },
    {
      image: MenuImg4,
      name: 'Mexican Burger',
      price: 9.99,
      description: 'Class aptent taciti ciosqu litora torquent per',
    },
  ],
};

export const testimonialData = {
  title: "what client's say ",
  subtitle: '1500+ statisfied clients',
  modelImg: ModelWhiteImg,
  slider: [
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar1,
      name: 'Rick Thompson',
      occupation: 'CEO of Delightful',
    },
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar2,
      name: 'John Doe',
      occupation: 'CEO of Delightful',
    },
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar3,
      name: 'Henry A.',
      occupation: 'CEO of Delightful',
    },
  ],
};

export const reservationData = {
  title: 'booking form',
  subtitle:
    'Ligue (47) 3041-8737 das 08:00 às 00:00, ou faça a sua reserva online aqui. Requer no mínimo 4 pessoas ou mais.',
  modelImg: ModelBlackImg,
  btnText: 'make a reservation',
};

export const newsletterData = {
  title: 'join our newsletter',
  subtitle: 'Get latest news & updates in your inbox.',
  placeholder: 'Enter your email',
  btnText: 'subscribe now',
};

export const footerData = {
  contact: {
    title: 'contact location',
    address: 'R. 7 de Setembro, 1213 - Centro, Blumenau - SC, 89010-201',
    phone: '(47) 3041-8737',
  },
  hours: {
    title: 'working hours',
    program: [
      {
        days: 'segunda - sexta',
        hours: '08:00 - 00:00',
      },
      {
        days: 'sábado - domingo',
        hours: '10:00 - 11:00',
      },
    ],
  },
  social: {
    title: 'social network',
  },
};
